import { InsuranceCarrier, insuranceCarrierDefs } from '@shared';

const NEW_YORK_LIFE_NAME = insuranceCarrierDefs[InsuranceCarrier.NewYorkLife].name.toLowerCase();

/**
 * Resolves the small square carrier mark shown in product/quote badges. Most
 * carriers have a `/logos/<lowercased-name>.svg`, but New York Life only ships a
 * raster logo, so resolve it explicitly to avoid a broken image.
 */
export function getCarrierLogoSrc(carrierName?: string | null): string {
  const name = carrierName?.toLowerCase() ?? '';
  if (name === NEW_YORK_LIFE_NAME) {
    return '/logos/nyl-logo.png';
  }
  return `/logos/${name}.svg`;
}
